import axios, {AxiosInstance} from 'axios';
import {getAuthServiceInstance} from "./auth";
import {isProd} from "../lib";

let instance:AxiosInstance;

const isLoginPage = () => window.location.pathname === "/app/login"

const responseSuccessHandler = (response: any) => response;
const responseErrorHandler = (error: any, navigate: any) => {
    if (error.response) {
        if (error.response.status === 401) {
            // 로그인 만료 시 alert 를 여러번 띄우는 것을 방지
            if (isLoginPage()) return

            alert("로그인이 만료되었습니다. 로그인을 다시해주세요.");
            getAuthServiceInstance(navigate).logout();
            navigate('/app/login', {replace: true});
        }

    } else if (error.request) {
        if (error.message !== "Network Error") {
            return Promise.reject(error);
        }

        const {config} = error;
        config._retry = config._retry === undefined ? 0 : ++config._retry;

        if (config._retry > 5) {
            return Promise.reject(error)
        }

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const instance = axiosInstance(navigate);
                resolve(instance.request(config));
            }, 1000)
        })

    } else {
        console.log(error.config)
    }

    return Promise.reject(error);
}


export default function axiosInstance(navigate: any) {
    if (instance === undefined) {
        const baseURL = isProd() ? '/' : process.env.REACT_APP_API_HOST;
        const axiosConfig = {
            baseURL,
            timeout: 5000,
            headers: { 'Pragma': 'no-cache', 'Cache-Control': 'no-cache, no-store' }
        }
        instance = axios.create(axiosConfig);

        instance.interceptors.response.use(
          response => responseSuccessHandler(response),
          error => responseErrorHandler(error, navigate));
    }

    return instance
}
